import { KlexikonService, KlexikonTeaserRes, Language } from '@shared/openapi/jaaluu-api';
import { Ref, ref } from 'vue';

export default () => {
  const klexArticles: Ref<KlexikonTeaserRes[]> = ref([]);
  const maxLoadKlexikon = ref(0);

  const getRandomKlexikonArticles = (
    n: number,
    lang: Language,
    _klexArticles: KlexikonTeaserRes[]
  ) => {
    return KlexikonService.getTeasersV1KlexikonTeasersGet({
      query: { lang, n },
      throwOnError: true
    }).then((res) => {
      if (res.data) {
        _klexArticles.push(...res.data);
      }
    });
  };

  const getSearchedKlexikonArticles = (
    search: string,
    lang: Language,
    _klexArticles: KlexikonTeaserRes[]
  ) => {
    return KlexikonService.searchTeasersV1KlexikonTeasersSearchGet({
      query: {
        q: search,
        lang
      }
    }).then((res) => {
      if (res.data) {
        _klexArticles.push(...res.data);
      }
    });
  };

  return {
    state: { klexArticles, maxLoadKlexikon },
    funcs: { getRandomKlexikonArticles, getSearchedKlexikonArticles }
  };
};
